import { Directive, HostListener, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from '@proman/rxjs-common';

import { FilterService } from '@proman/services/filter.service';
import { OverlayService } from '../../shared/services/overlay.service';

import { debounce } from '@proman/utils';
import { DocsIdValues } from '@proman/store/docs-id/docs-id.reducer';
import { getDocsIdData } from '@proman/store/docs-id/docs-id.selectors';

@Directive({
    selector: '[docsId]',
    standalone: false
})
export class DocsIdDirective implements OnInit, OnDestroy {
    private Overlay = inject(OverlayService);
    private Filter = inject(FilterService);
    private store = inject(Store);

    @Input('docsId') key: string|null;

    visible: boolean = false;
    toBeShown: boolean = false;

    debounceShow: any;
    debounceHide: any;

    _docsActive: Subscription;
    isDocsActive: boolean;
    docsIdData: DocsIdValues;

    @HostListener('mouseenter', ['$event'])
    public setOverlayData($event: MouseEvent) {
        if (!this.docsIdData) return;
        this.debounceShow($event);

        this.toBeShown = true;
    }

    @HostListener('mouseleave')
    public disableOverlay() {
        if (!this.docsIdData) return;

        if (!this.visible) {
            this.debounceShow.cancel();
        } else {
            this.debounceHide();
            this.visible = false;
        }

        this.toBeShown = true;
    }

    ngOnInit() {
        this._docsActive = this.Overlay.docActive.pipe(
            distinctUntilChanged())
            .subscribe((value: any) => {
                this.isDocsActive = value;
            });

        this.store
            .select(getDocsIdData)
            .subscribe((data) => {
                this.docsIdData = data[this.Filter.translate(this.key)];
            });

        this.debounceShow = debounce(($event: MouseEvent) => {
            this.Overlay.docsSetKey(this.docsIdData);
            this.Overlay.docsShow($event);

            this.visible = true;

        }, 850);

        this.debounceHide = debounce(() => {
            if (!this.isDocsActive) this.Overlay.docsHide();

        }, 400);
    }

    ngOnDestroy() {
        if (this.toBeShown) this.debounceShow.cancel();
        if (this.visible) this.Overlay.docsHide();
    }

}
